export default __webpack_public_path__ + "static/media/ss2.06114c44.png";